jQuery(document).ready(function( $ ) {

    // Touch device detection
    function is_touch_enabled() {
        return ( 'ontouchstart' in window ) || 
               ( navigator.maxTouchPoints > 0 ) || 
               ( navigator.msMaxTouchPoints > 0 );
    }

    if ( !is_touch_enabled() ) {
        $('body').addClass('no-touch');
    } else {
        $('body').addClass('is-touch');
    };

    // contact form script
    var $group_tags = $('.wpforms-form .list-of-procedures select').find('option[value="group-start"]');

    $group_tags.each(function(i, e) {
        var label = $(e).text();
        $(e).nextUntil($group_tags).wrapAll('<optgroup label="'+label+'" />');
        $(e).remove();
    });

    // fix for empty elementor columns which only have background image
    // and no content to maintain height on mobile, it add extra class to
    // spacer widget to maintain height on small screens
    $('.elementor-element-populated').each(function() {

        let $count = $(this).find('.elementor-widget-wrap').children('div').length;
        if ( $count < 2 ) {
            if ( $(this).css('background-image') !== 'none' ) {
                $(this).find('.elementor-spacer-inner').addClass('dummy-spacer');
            }
        }
    })

});